import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { DirectSubnavModule } from '@app/modules/direct/components/direct-subnav/direct-subnav.module';
import { NestedSubnavComponent } from '@app/modules/menu-mobile/nested-subnav.component';
import { SharedModule } from '@app/shared/shared.module';
import { MenuItemComponent } from './menu-item.component';
import { MenuMobileRoutingModule } from './menu-mobile-routing.module';
import { MenuMobileComponent } from './menu-mobile.component';

@NgModule({
  declarations: [MenuMobileComponent, MenuItemComponent, NestedSubnavComponent],
  imports: [
    CommonModule,
    MenuMobileRoutingModule,
    MatMenuModule,
    MatDividerModule,
    RouterModule,
    SharedModule,
    DirectSubnavModule,
  ],
  exports: [MenuMobileComponent, MenuItemComponent, NestedSubnavComponent],
})
export class MenuMobileModule {}
